import React from 'react';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  number?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, subtitle, icon, number }) => (
  <div className="relative group">
    <div className="flex items-center gap-6">
      {icon && (
        <div className="h-14 w-14 bg-slate-50 rounded-[1.25rem] flex items-center justify-center text-hr-indigo shadow-sm group-hover:bg-hr-indigo group-hover:text-white transition-colors duration-300 border border-slate-100">
          {icon}
        </div>
      )}
      {number && !icon && (
        <div className="h-14 w-14 bg-hr-indigo rounded-[1.25rem] flex items-center justify-center text-white font-black text-lg shadow-xl shadow-hr-indigo/20">
          {number}
        </div>
      )}
      <div className="space-y-1">
        <h3 className="text-lg font-black text-hr-indigo tracking-tight leading-none">{title}</h3>
        {subtitle && (
          <p className="text-micro font-bold text-slate-400 uppercase tracking-[0.3em]">
            {subtitle}
          </p>
        )}
      </div>
    </div>
    <div className="h-px bg-gradient-to-r from-hr-pink/30 via-slate-200 to-transparent mt-6" />
  </div>
);
